module.exports = require('./build/mediaelement-and-player.js');



//////////////////
// WEBPACK FOOTER
// ./node_modules/mediaelement/full.js
// module id = 136
// module chunks = 0